import { render, staticRenderFns } from "./LawCounterPartySubTypeForm.vue?vue&type=template&id=2c2b8c10&"
import script from "./LawCounterPartySubTypeForm.vue?vue&type=script&lang=js&"
export * from "./LawCounterPartySubTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./LawCounterPartySubTypeForm.vue?vue&type=style&index=0&id=2c2b8c10&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports